<ion-app>
    <ion-router-outlet id="content" main></ion-router-outlet>
</ion-app>
